let ctx: AudioContext | null = null

function getCtx(): AudioContext {
  if (!ctx) {
    const AudioCtor = (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)
    ctx = new AudioCtor()
  }
  if (ctx.state === 'suspended') void ctx.resume()
  return ctx
}

function midiZuFrequenz(midi: number): number {
  return 440 * Math.pow(2, (midi - 69) / 12)
}

interface KlangOptionen {
  dauer?: number
  amplitude?: number
  onStart?: (midi: number) => void
  onEnd?: (midi: number) => void
}

export function spieleTon(midi: number, opts: KlangOptionen = {}): void {
  const c        = getCtx()
  const dauer    = opts.dauer ?? 0.6
  const amp      = opts.amplitude ?? 0.18
  const startZeit = c.currentTime
  const freq     = midiZuFrequenz(midi)

  const gain = c.createGain()
  gain.connect(c.destination)
  gain.gain.setValueAtTime(0, startZeit)
  gain.gain.linearRampToValueAtTime(amp, startZeit + 0.01)
  gain.gain.exponentialRampToValueAtTime(amp * 0.4, startZeit + 0.2)
  gain.gain.exponentialRampToValueAtTime(0.0001, startZeit + dauer)

  const oszillatoren: OscillatorNode[] = []
  const partiale = [
    { harmonic: 1, gain: 1.0, type: 'sine' as OscillatorType },
    { harmonic: 2, gain: 0.35, type: 'sine' as OscillatorType },
    { harmonic: 3, gain: 0.18, type: 'triangle' as OscillatorType },
  ]
  for (const p of partiale) {
    const o = c.createOscillator()
    o.type = p.type
    o.frequency.value = freq * p.harmonic
    const partialGain = c.createGain()
    partialGain.gain.value = p.gain
    o.connect(partialGain)
    partialGain.connect(gain)
    o.start(startZeit)
    o.stop(startZeit + dauer + 0.05)
    oszillatoren.push(o)
  }

  opts.onStart?.(midi)
  window.setTimeout(() => opts.onEnd?.(midi), dauer * 1000)
}

export function spieleSequenz(midis: number[], abstandMs = 220, opts: KlangOptionen = {}): void {
  midis.forEach((midi, i) => {
    window.setTimeout(() => spieleTon(midi, opts), i * abstandMs)
  })
}

export function spieleAkkord(midis: number[], opts: KlangOptionen = {}): void {
  midis.forEach(midi => spieleTon(midi, { ...opts, dauer: opts.dauer ?? 1.2 }))
}

export function kadenz(tonicMidi: number, opts: KlangOptionen = {}): void {
  const i  = [tonicMidi, tonicMidi + 4, tonicMidi + 7]
  const iv = [tonicMidi + 5, tonicMidi + 9, tonicMidi + 12]
  const v  = [tonicMidi + 7, tonicMidi + 11, tonicMidi + 14]
  const akkorde = [i, iv, v, i]
  akkorde.forEach((akkord, idx) => {
    window.setTimeout(() => spieleAkkord(akkord, { dauer: 0.9, ...opts }), idx * 900)
  })
}
